import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonus() {
  const bonuses = [{
    num: '01',
    title: 'Qué Decir en Consulta Infantil',
    desc: 'Qué decir, cómo explicarlo y cómo bajar mejor el mensaje.',
    val: '$8.990'
  }, {
    num: '02',
    title: 'Plantillas Express para Consulta Infantil',
    desc: 'Material simple para registrar objetivos y avances.',
    val: '$7.990'
  }, {
    num: '03',
    title: 'Ruta Clara de Intervención Infantil',
    desc: 'Qué hacer cuando el nene no incorpora y la familia no sostiene.',
    val: '$8.990'
  }, {
    num: '04',
    title: 'Cómo Manejar Objeciones de Familias',
    desc: 'Para ordenar la evaluación infantil en menos tiempo.',
    val: '$7.990'
  }, {
    num: '05',
    title: 'Mapa Rápido de Estrategias para Casos Infantiles',
    desc: 'Mini recursos para entregar entre consultas.',
    val: '$7.990'
  }, {
    num: '06',
    title: 'Recursos Imprimibles para usar en consulta',
    desc: 'Apoyo simple para educación alimentaria infantil.',
    val: '$7.990'
  }];
  return <section className="py-10 md:py-14 px-4 bg-black border-y border-sand/10" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <FadeIn className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-terracotta/10 text-terracotta mb-6" data-id="element-16">
            <Gift size={32} data-id="element-17" />
          </div>
          <span className="text-sand text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-18">
            Bonos exclusivos
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-19">
            +6 Bonos GRATIS al instante
          </h2>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto mb-8" data-id="element-20">
            Recursos extra para que empieces con todo, sin costo adicional.
          </p>

          <div className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-4 bg-black border border-sand/20 rounded-full px-6 py-3" data-id="element-21">
            <span className="text-cream/50 line-through" data-id="element-22">
              Valor real: $49.990
            </span>
            <span className="hidden sm:block text-sand/30" data-id="element-23">•</span>
            <span className="text-terracotta font-bold" data-id="element-24">Hoy pagás: $0</span>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-25">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-26">
              <div className="glow-beige bg-black rounded-2xl p-6 h-full relative group transition-all" data-id="element-27">
                <div className="absolute top-6 right-6 text-4xl font-display font-bold text-sand/10 group-hover:text-sand/20 transition-colors" data-id="element-28">
                  {bonus.num}
                </div>

                <div className="mb-4" data-id="element-29">
                  <span className="inline-block bg-terracotta/20 text-terracotta text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider mb-3" data-id="element-30">
                    Gratis
                  </span>
                  <h3 className="font-display text-xl font-bold text-cream mb-2 pr-8" data-id="element-31">
                    {bonus.title}
                  </h3>
                  <p className="text-cream/60 text-sm leading-relaxed" data-id="element-32">
                    {bonus.desc}
                  </p>
                </div>

                <div className="mt-auto pt-4 border-t border-sand/10" data-id="element-33">
                  <p className="text-xs text-cream/40 uppercase tracking-wider" data-id="element-34">
                    Valor: <span className="line-through" data-id="element-35">{bonus.val}</span>
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-36">
          <p className="text-cream/50 text-sm font-bold tracking-widest uppercase" data-id="element-37">
            Acceso inmediato • Todos los bonos en PDF • Sin letra chica
          </p>
        </FadeIn>
      </div>
    </section>;
}